/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum DiscrepanciesUnit {
  Piece = 'PIECE',
  QuarterDisplay = 'QUARTER_DISPLAY',
  HalfDisplay = 'HALF_DISPLAY',
  Carton = 'CARTON',
  Pallet = 'PALLET',
  Colli = 'COLLI'
}
